import React, { useState } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  Slide,
} from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { CancelButton, SaveButton } from './DriverCardModal';
import useBulkEditRecruiters from 'src/hooks/useBulkEditRecruiters';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const validationSchema = Yup.object({
  recruiter: Yup.string().required('Recruiter is required'),
});

export const EditAssignRecruiters = ({
  recruiters,
  selectedRowsRef,
  resetSelection,
  companyId,
  setLeads,
  selectedRef,
  setNotificationHandler,
  setOpenNotification,
}) => {
  const [showModal, setShowModal] = useState(false);

  const { bulkEditRecruiters } = useBulkEditRecruiters();
  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    selectedRef = [];
    setShowModal(false);
    resetSelection();
  };

  const handleBulkEdit = async (values, { setSubmitting }) => {
    try {
      await bulkEditRecruiters(selectedRowsRef.current, values.recruiter, companyId);
      selectedRef = [];
      setLeads(
        (prevLeads) =>
          prevLeads.map((lead) =>
            selectedRowsRef.current.includes(lead.lead_id) ? { ...lead, lead_recruiter_id: values.recruiter } : lead
          )
        // .filter((lead) => !filterByRecruiter || lead.lead_recruiter_id === filterByRecruiter)
      );
      resetSelection();
      setShowModal(false);
      setNotificationHandler({
        title: 'You have successfully assigned a recruiter!',
        severity: 'success',
      });
      setOpenNotification(true);
    } catch (error) {
      console.error('Error assigning recruiter:', error);
      setNotificationHandler({
        title: 'There was a problem assigning a recruiter!',
        severity: 'error',
      });
      setOpenNotification(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        sx={{
          textTransform: 'capitalize',
          backgroundColor: 'rgb(255,247,205)',
          mx: '2px',
          my: '2px',
          color: 'rgb(2, 128, 144)',
          '&:hover': {
            color: 'red',
            backgroundColor: 'rgba(255,247,205,0.5)',
          },
          height: '36px',
        }}
        onClick={handleButtonClick}
      >
        Assign Recruiter
      </Button>

      <Dialog
        open={showModal}
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            width: '30%',
            maxWidth: 'none',
            overflow: 'visible',
            position: 'relative',
          },
        }}
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <Box
          sx={{
            py: '6px',
            boxShadow: '0px 0px 12px rgba(0, 0, 0, 0.15)',
            borderRadius: '10px',
            zIndex: 1,
          }}
        >
          <DialogTitle
            sx={{
              fontSize: '24px !important',
              py: '6px',
              textAlign: 'center',
              textTransform: 'capitalize',
            }}
          >
            Assign Recruiter
          </DialogTitle>
        </Box>

        <Formik initialValues={{ recruiter: '' }} validationSchema={validationSchema} onSubmit={handleBulkEdit}>
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              {/* <DialogContent
                className="modern-scrollbar"
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  p: '20px 40px',
                }}
              >
                Selected {selectedRowsRef.current.length}.
              </DialogContent> */}

              <DialogContent
                className="modern-scrollbar"
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  p: '20px 40px',
                }}
              >
                Recruiter
                <Select
                  id="assignRecruiter"
                  fullWidth
                  displayEmpty
                  value={values.recruiter}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  name="recruiter"
                  error={touched.recruiter && Boolean(errors.recruiter)}
                >
                  <MenuItem value="" disabled>
                    -- Select Recruiter --
                  </MenuItem>
                  {recruiters.map((recruiter) => (
                    <MenuItem key={recruiter.recruiter_id} value={String(recruiter.recruiter_id)}>
                      {recruiter.recruiter_full_name}
                    </MenuItem>
                  ))}
                </Select>
                {touched.recruiter && errors.recruiter && (
                  <div style={{ color: 'red', marginTop: '5px' }}>{errors.recruiter}</div>
                )}
              </DialogContent>
              <DialogContent
                className="modern-scrollbar"
                sx={{
                  flex: 1,
                  overflowY: 'auto',
                  p: '20px 40px',
                }}
              >
                Assign {selectedRowsRef.current.length} leads to the selected recruiter.
              </DialogContent>
              <DialogActions>
                <CancelButton onClick={handleClose}>Cancel</CancelButton>
                <SaveButton type="submit" disabled={isSubmitting}>
                  {isSubmitting ? <CircularProgress size={24} /> : 'Save'}
                </SaveButton>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>
    </>
  );
};
